var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lang-select" },
    [
      _c(
        "el-dropdown",
        {
          staticClass: "international",
          attrs: { trigger: "click" },
          on: { command: _vm.handleSetLanguage },
        },
        [
          _c(
            "div",
            [
              _c("svg-icon", {
                attrs: {
                  "class-name": "international-icon",
                  "icon-class": "language",
                },
              }),
              _c("span", { staticClass: "lang-text" }, [
                _vm._v(_vm._s(_vm.language === "zh" ? "Chinese" : "English")),
              ]),
              _c("i", { staticClass: "el-icon-caret-bottom icon-arrow-down" }),
            ],
            1
          ),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            [
              _c(
                "el-dropdown-item",
                { attrs: { disabled: _vm.language === "zh", command: "zh" } },
                [
                  _c("span", { staticClass: "country-text" }, [
                    _vm._v("Chinese"),
                  ]),
                ]
              ),
              _c(
                "el-dropdown-item",
                { attrs: { disabled: _vm.language === "en", command: "en" } },
                [
                  _c("span", { staticClass: "country-text" }, [
                    _vm._v("English"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }